import 'slick-carousel'

export default () => {
  $('.slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    appendArrows: '.slideshow__arrows',
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                  </svg>
                </button>`,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                  </svg>
                </button>`
  });

  $('.category-list ul').slick({
    slidesToShow: 4,
    rows: 2,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                  </svg>
                </button>`,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                  </svg>
                </button>`,
                responsive: [
                  {
                    breakpoint: 1250,
                    settings: {
                      slidesToShow: 3
                    }
                  },
                  {
                    breakpoint: 1023,
                    settings: {
                      slidesToShow: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: false,
                      dots: true,
                      slidesToShow: 1
                    }
                  }
                ]
  });

  $('.partners').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                  </svg>
                </button>`,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                  </svg>
                </button>`,
                responsive: [
                  {
                    breakpoint: 1250,
                    settings: {
                      slidesToShow: 3
                    }
                  },
                  {
                    breakpoint: 1023,
                    settings: {
                      slidesToShow: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: false,
                      dots: true,
                      slidesToShow: 2
                    }
                  }
                ]
  });

  $('.news-slider__big').slick({
    slidesToShow: 1,
    fade: true,
    slidesToScroll: 1,
    asNavFor: '.news-slider__small',
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                  </svg>
                </button>`,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                  </svg>
                </button>`
  });

  $('.news-slider__small').slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.news-slider__big',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });

  $('.reviews__slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                  </svg>
                </button>`,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                  </svg>
                </button>`,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          arrows: false
        }
      },
      {
        breakpoint: 1023,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });

  $('.team__slider').each(function() {
    const arrowContainer = $(this).siblings('.team__top').children('.team__control');
    $(this).slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      appendArrows: arrowContainer,
      dots: true,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                    </svg>
                  </button>`,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ]
    });
  });
  $('.add-team__slider').each(function() {
    const arrowContainer = $(this).siblings('.add-team__top').children('.add-team__control');
    $(this).slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      appendArrows: arrowContainer,
      dots: true,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                    </svg>
                  </button>`,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  $('.programm__slider').each(function() {
    const arrowContainer = $(this).siblings('.programm__top').children('.programm__control');
    $(this).slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      appendArrows: arrowContainer,
      dots: true,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                    </svg>
                  </button>`,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            centerMode: false,
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });
  });

  $('.department__slider').each(function() {
    const arrowContainer = $(this).siblings('.department__top').children('.department__control');
    $(this).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: arrowContainer,
      dots: true,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                    </svg>
                  </button>`,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            centerMode: false,
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });
  });

  $('.important-info').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                  </svg>
                </button>`,
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                  </svg>
                </button>`,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  });

  $('.foto-gallery__slider').each(function() {
    const arrowContainer = $(this).siblings('.foto-gallery__top').children('.foto-gallery__control');
    $(this).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      appendArrows: arrowContainer,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.05664 1.88669L6.16995 8L0.0566405 14.1133L1.94327 16L9.94326 8L1.94326 2.77856e-06L0.05664 1.88669Z"/>
                    </svg>
                  </button>`,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.94336 1.88669L3.83005 8L9.94336 14.1133L8.05673 16L0.0567354 8L8.05674 2.77856e-06L9.94336 1.88669Z"/>
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });




  function customSlider1() {
    let slickSlide = $('.showroom__text-slider');
    let slideCount = $('.slide-count');

    slickSlide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      const i = (currentSlide ? currentSlide : 0) + 1;
      $(this).parents('.showroom__slider-section').siblings('.showroom__top').find('.slide-count').html('<span class="slide-number">' + i + '</span> ' + ' <span class="slide-score">' + slick.slideCount + '</span>');
    });
    $('.showroom__text-slider').each(function() {
      const arrowContainer = $(this).parents('.showroom__slider-section').siblings('.showroom__top').children('.showroom__control');
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: arrowContainer,
        asNavFor: '.showroom__image-slider',
        prevArrow: `<button type="button" class="slick-prev">
                      <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.646442 4.35355C0.45118 4.15829 0.45118 3.84171 0.646442 3.64645L3.82842 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.73079 0.659728 4.73079 0.976311 4.53553 1.17157L1.7071 4L4.53553 6.82843C4.73079 7.02369 4.73079 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82842 7.53553L0.646442 4.35355ZM61 4.5H0.999996V3.5H61V4.5Z" />
                      </svg>
                    </button>`,
        nextArrow: `<button type="button" class="slick-next">
                      <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                        <path d="M60.3536 4.35355C60.5488 4.15829 60.5488 3.84171 60.3536 3.64645L57.1716 0.464466C56.9763 0.269204 56.6597 0.269204 56.4645 0.464466C56.2692 0.659728 56.2692 0.976311 56.4645 1.17157L59.2929 4L56.4645 6.82843C56.2692 7.02369 56.2692 7.34027 56.4645 7.53553C56.6597 7.7308 56.9763 7.7308 57.1716 7.53553L60.3536 4.35355ZM0 4.5H60V3.5H0V4.5Z" />
                      </svg>
                    </button>`,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false
            }
          }
        ]
      });
    });
  }customSlider1();

  $('.showroom__image-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    asNavFor: '.showroom__text-slider',
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.showroom__sub-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.showroom__image-add-slider'
  });

  $('.showroom__image-add-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.showroom__sub-slider',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.certificates__slider').each(function() {
    const arrowContainer = $(this).siblings('.certificates__top').children('.certificates__top-box');
    $(this).slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      appendArrows: arrowContainer,
      centerMode: true,
      centerPadding: '0px',
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.646442 4.35355C0.45118 4.15829 0.45118 3.84171 0.646442 3.64645L3.82842 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.73079 0.659728 4.73079 0.976311 4.53553 1.17157L1.7071 4L4.53553 6.82843C4.73079 7.02369 4.73079 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82842 7.53553L0.646442 4.35355ZM61 4.5H0.999996V3.5H61V4.5Z" />
                    </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                      <path d="M60.3536 4.35355C60.5488 4.15829 60.5488 3.84171 60.3536 3.64645L57.1716 0.464466C56.9763 0.269204 56.6597 0.269204 56.4645 0.464466C56.2692 0.659728 56.2692 0.976311 56.4645 1.17157L59.2929 4L56.4645 6.82843C56.2692 7.02369 56.2692 7.34027 56.4645 7.53553C56.6597 7.7308 56.9763 7.7308 57.1716 7.53553L60.3536 4.35355ZM0 4.5H60V3.5H0V4.5Z" />
                    </svg>
                  </button>`,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            centerMode: false,
            centerPadding: '0px',
            slidesToShow: 1
          }
        }
      ]
    });
  });

function slickCarouselb() {
  $('.product-section__big-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          dots: true
        }
      }
    ]
  });
}
slickCarouselb();
function slickCarousels() {
  $('.product-section__small-slider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    accessibility: false,
    focusOnSelect: true,
    asNavFor: '.product-section__big-slider',
    prevArrow: `<button type="button" class="slick-prev">
                  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.10184 4.8737C0.238831 5.00174 0.461439 5.00174 0.59843 4.8737L4.96499 0.784333L9.34012 4.87369C9.47711 5.00174 9.69972 5.00174 9.83671 4.87369C9.9737 4.74565 9.9737 4.53758 9.83671 4.40954L5.22185 0.0961036C5.15336 0.0320825 5.06774 7.19515e-05 4.97356 7.19597e-05C4.88794 7.19672e-05 4.79376 0.0320825 4.72526 0.0961036L0.110402 4.40954C-0.0351496 4.53758 -0.0351505 4.74565 0.10184 4.8737Z" fill="#444444"/>
                  </svg>
                </button>`,
    nextArrow: `<button type="button" class="slick-next">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.83761 0.94027C9.70062 0.812228 9.47801 0.812228 9.34102 0.94027L4.97446 5.02963L0.599332 0.94027C0.462342 0.812228 0.239733 0.812228 0.102743 0.94027C-0.0342476 1.06831 -0.0342476 1.27638 0.102743 1.40443L4.7176 5.71786C4.7861 5.78188 4.87172 5.81389 4.9659 5.81389C5.05152 5.81389 5.1457 5.78188 5.21419 5.71786L9.82905 1.40443C9.9746 1.27638 9.9746 1.06831 9.83761 0.94027Z" fill="#444444"/>
                  </svg>
                </button>`
  });
}
slickCarousels();


  $('.about-holder__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.about-holder__years-slider',
    arrows: false
  });

  $('.about-holder__years-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    variableWidth: true,
    asNavFor: '.about-holder__slider'
  });

  $('.delivery-section__slider').each(function() {
    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: `<button type="button" class="slick-prev">
                    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.646446 4.35355C0.451184 4.15829 0.451184 3.84171 0.646446 3.64645L3.82843 0.464467C4.02369 0.269205 4.34027 0.269204 4.53553 0.464467C4.7308 0.659729 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM11 4.5L1 4.5L1 3.5L11 3.5L11 4.5Z" fill="#3D3D3D"/>
                    </svg>
                  </button>`,
      nextArrow: `<button type="button" class="slick-next">
                    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.3536 4.35355C10.5488 4.15829 10.5488 3.84171 10.3536 3.64645L7.17157 0.464467C6.97631 0.269205 6.65973 0.269204 6.46447 0.464467C6.2692 0.659729 6.2692 0.976311 6.46447 1.17157L9.29289 4L6.46447 6.82843C6.2692 7.02369 6.2692 7.34027 6.46447 7.53553C6.65973 7.7308 6.97631 7.7308 7.17157 7.53553L10.3536 4.35355ZM-4.37114e-08 4.5L10 4.5L10 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z" fill="#3D3D3D"/>
                    </svg>
                  </button>`
    });
  });

  function customSlider2() {
    let slickSlide = $('.gallery-inner__slider');
    let slideCount = $('.slide-count');

    slickSlide.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      const i = (currentSlide ? currentSlide : 0) + 1;
      $(this).siblings('.gallery-inner__count').find('.slide-count').html('<span class="slide-number">' + i + '</span> ' + ' <span class="slide-score">' + slick.slideCount + '</span>');
    });
    $('.gallery-inner__slider').each(function() {
      $(this).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.gallery-inner__add-slider',
        prevArrow: `<button type="button" class="slick-prev">
                      <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.646442 4.35355C0.45118 4.15829 0.45118 3.84171 0.646442 3.64645L3.82842 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.73079 0.659728 4.73079 0.976311 4.53553 1.17157L1.7071 4L4.53553 6.82843C4.73079 7.02369 4.73079 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82842 7.53553L0.646442 4.35355ZM61 4.5H0.999996V3.5H61V4.5Z" />
                      </svg>
                    </button>`,
        nextArrow: `<button type="button" class="slick-next">
                      <svg width="61" height="8" viewBox="0 0 61 8" xmlns="http://www.w3.org/2000/svg">
                        <path d="M60.3536 4.35355C60.5488 4.15829 60.5488 3.84171 60.3536 3.64645L57.1716 0.464466C56.9763 0.269204 56.6597 0.269204 56.4645 0.464466C56.2692 0.659728 56.2692 0.976311 56.4645 1.17157L59.2929 4L56.4645 6.82843C56.2692 7.02369 56.2692 7.34027 56.4645 7.53553C56.6597 7.7308 56.9763 7.7308 57.1716 7.53553L60.3536 4.35355ZM0 4.5H60V3.5H0V4.5Z" />
                      </svg>
                    </button>`,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });
    });
  }customSlider2();

  $('.gallery-inner__add-slider').slick({
    slidesToShow: 12,
    slidesToScroll: 1,
    focusOnSelect: true,
    asNavFor: '.gallery-inner__slider',
    arrows: false,
    responsive: [
      {
      breakpoint: 1439,
      settings: {
        slidesToShow: 7
      }
    },
      {
      breakpoint: 1250,
      settings: {
        slidesToShow: 7
      }
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3
      }
    }
    ]
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js